import React from "react";

interface TextWithLineBreaksProps {
  text: string;
}

const TextWithLineBreaks: React.FC<TextWithLineBreaksProps> = ({ text }) => {
  const parts = text.split(/<br\s*\/?>|\n/);

  return parts.map((item, index, array) => (
    <React.Fragment key={index}>
      {item}
      {index !== array.length - 1 && <br />}
    </React.Fragment>
  ));
};

export { TextWithLineBreaks };
